import { SelectionModel } from "@angular/cdk/collections";
import { FlatTreeControl } from "@angular/cdk/tree";
import { Component, EventEmitter, Injectable, Input, OnInit, Output } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { MatSelectChange } from "@angular/material/select";
import { CategoriaDTO } from "app/main/apps/shared/interfaces/categoria.interface";
import { CatalogoService } from "app/main/apps/shared/services/rest/catalogo.service";

export class TodoItemNode {
    children: TodoItemNode[];
    item: string;
}

@Component({
    selector: "app-lista-grupos-catalogo",
    templateUrl: "./lista-grupos-catalogo.component.html",
    styleUrls: ["./lista-grupos-catalogo.component.scss"],
})
export class ListaGruposCatalogoComponent implements OnInit {
    formulario: FormGroup;
    @Input() grupos: CategoriaDTO[];
    @Output() idGrupoEmitter: EventEmitter<number> = new EventEmitter();
    constructor(private fb: FormBuilder,private _catalogoSrvc: CatalogoService) {
       
    }
    ngOnInit(): void {
        this.formulario = this.fb.group({
            grupo: [-1,null]
        });

        //Cada vez que cambia de pestaña, seteo el combobox en "seleccione..."
        this._catalogoSrvc.onCategoriaChanged.subscribe(resp=>{
            //console.log('llego');
            this.formulario.get("grupo").setValue(-1);
        });
    }

    get grupo() {
        return this.formulario.get("grupo");
    }

    cargarServicio(event:MatSelectChange){
        this.idGrupoEmitter.emit(event.value);
    }


}
